import '.c3{position:relative;}.ssr-plugin'
import '.i{width:100%;}.ssr-plugin'
import '.fz{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.x{justify-content:center;}.ssr-plugin'
import '.c6{align-items:flex-start;}.ssr-plugin'
import '.k{padding:2rem;}.ssr-plugin'
import '.cu{background:var(--shades-white);}.ssr-plugin'
import '.a6{overflow:hidden;}.ssr-plugin'
import '.a2{position:absolute;}.ssr-plugin'
import '.ie{top:50%;}.ssr-plugin'
import '.if{right:1rem;}.ssr-plugin'
import '.ig{transform:translateY(-50%);}.ssr-plugin'
import '.ih{width:120px;}.ssr-plugin'
import '.ii{height:120px;}.ssr-plugin'
import '.ij{z-index:0;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.hg{z-index:1;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.ik{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c3 i fz a b x c6 k cu a6"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="a2 ie if ig ih ii ij a l x"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c3 hg a b c6 al ik"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
